import {Component, OnInit} from '@angular/core';
import {NotificationsService} from 'angular2-notifications';
import {TranslateService} from '@ngx-translate/core';
import {BankTransactionService} from '../../bank-transaction/bank-transaction.service';
import {
  FinancialOperationRefundService
} from '../../../financial-operation/financial-operation-list/financial-operation-view/financial-operation-refund.service';

@Component({
  selector: 'app-transaction-action-column-renderer',
  templateUrl: './balance-package-purchase-action-renderer.component.html',
})
export class BalancePackagePurchaseActionRendererComponent implements OnInit {

  public params: any;
  public icons = [];

  constructor(
    public notif: NotificationsService,
    public translate: TranslateService,
    protected financialOperationRefundService: FinancialOperationRefundService
  ) { }

  ngOnInit() { }

  agInit(params: any): void {
    this.params = params;
    if (
      this.params
      && this.params.data
      && this.params.data.financialOperation
      && this.params.data.financialOperation.canBeRefunded
    ) {
      this.icons.push({
        class: this.getActionIconClass(BankTransactionService.REFUND),
        title: this.getActionIconTitle(BankTransactionService.REFUND),
        actionType: BankTransactionService.REFUND
      });
    }
    //   const status = this.params.data.endUserOrderTransaction.status;
    //   const process = BankTransactionService.BALANCE_PACKAGE_PURCHASE;
    //   const subscription = this.bankTransactionService.canRefundTransaction(
    //     process,
    //     status
    //   ).pipe(
    //     delay(0),
    //   ).subscribe(
    //     canRefund => {
    //       if (canRefund) {
    //         subscription.unsubscribe();
    //         this.icons.push({
    //           class: this.getActionIconClass(BankTransactionService.REFUND),
    //           title: this.getActionIconTitle(BankTransactionService.REFUND),
    //           actionType: BankTransactionService.REFUND
    //         });
    //       }
    //     }
    //   );
    // }
  }


  getActionIconClass(action: string) {
    return 'refund-transaction';
  }

  getActionIconTitle(action: string) {
    return this.translate.instant('Refund transaction');
  }

  onIconClick(actionType: string) {
    if (this.params.data && this.params.data.financialOperation.id
      && window.confirm(this.translate.instant('Are sure you want to refund this transaction') + '?')
    ) {
    //   // console.log(this.params.data.endUserOrderTransaction.id);
      this.financialOperationRefundService.refund(this.params.data.financialOperation.id)
        .subscribe(
          result => {
            if (result) {
              this.notif.success(this.translate.instant('Transaction was successfully refunded'));
            } else {
              this.notif.error(this.translate.instant('Error of transaction refund'));
            }
            this.params.context.refreshGrid();
          });
    }
  }

}
